<template>
  <button
    class="btn-sm"
    :data-testid="`${kind}-list-reset-numbers-button`"
    type="button"
    :disabled="pending"
    @click="$emit('reset')"
  >
    {{ pending ? 'Resetting numbers…' : 'Reset numbers' }}
  </button>
  <span v-if="notice" role="status" aria-live="polite">{{ notice }}</span>
</template>

<script setup>
defineProps({
  kind: { type: String, required: true },
  pending: Boolean,
  notice: { type: String, default: '' },
})
defineEmits(['reset'])
</script>
